import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="bg-brand-dark border-t border-brand-gold/10 py-8 px-6" data-id="element-51">
        <div className="max-w-4xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4 text-sm text-brand-cream/40" data-id="element-52">
          <p data-id="element-53">
            © {new Date().getFullYear()} Riqueza Integral. Todos los derechos
            reservados.
          </p>
          <div className="flex gap-6" data-id="element-54">
            <button onClick={() => setActiveModal('privacy')} className="hover:text-brand-gold transition-colors underline underline-offset-2" data-id="element-55">
              Política de Privacidad
            </button>
            <button onClick={() => setActiveModal('terms')} className="hover:text-brand-gold transition-colors underline underline-offset-2" data-id="element-56">
              Términos y Condiciones
            </button>
          </div>
        </div>
      </footer>

      <AnimatePresence data-id="element-57">
        {activeModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" onClick={() => setActiveModal(null)} data-id="element-58">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.25
        }} className="bg-brand-cream rounded-sm shadow-2xl max-w-2xl w-full max-h-[80vh] overflow-y-auto" onClick={e => e.stopPropagation()} data-id="element-59">
              <div className="sticky top-0 bg-brand-cream border-b border-gray-200 px-6 py-4 flex items-center justify-between" data-id="element-60">
                <h2 className="text-xl font-bold text-brand-green font-serif" data-id="element-61">
                  {activeModal === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones'}
                </h2>
                <button onClick={() => setActiveModal(null)} className="text-brand-dark/40 hover:text-brand-dark transition-colors p-1" aria-label="Cerrar" data-id="element-62">
                  <XIcon className="w-5 h-5" data-id="element-63" />
                </button>
              </div>

              <div className="px-6 py-8 text-brand-dark/80 leading-relaxed space-y-6 text-sm" data-id="element-64">
                {activeModal === 'privacy' ? <PrivacyContent data-id="element-65" /> : <TermsContent data-id="element-66" />}
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}
function PrivacyContent() {
  return <>
      <p className="text-xs text-brand-dark/50 uppercase tracking-wider" data-id="element-67">
        Última actualización: Mayo 2026
      </p>

      <section data-id="element-68">
        <h3 className="font-bold text-brand-green mb-2" data-id="element-69">
          1. Información que Recopilamos
        </h3>
        <p data-id="element-70">
          Recopilamos únicamente la información necesaria para procesar tu
          compra y entregarte el producto digital. Esto incluye tu nombre,
          dirección de correo electrónico y datos de pago procesados de forma
          segura a través de nuestro proveedor de pagos.
        </p>
      </section>

      <section data-id="element-71">
        <h3 className="font-bold text-brand-green mb-2" data-id="element-72">
          2. Uso de la Información
        </h3>
        <p data-id="element-73">Tu información personal se utiliza exclusivamente para:</p>
        <ul className="list-disc pl-5 mt-2 space-y-1" data-id="element-74">
          <li data-id="element-75">Procesar y entregar tu compra.</li>
          <li data-id="element-76">Enviarte el acceso al producto digital adquirido.</li>
          <li data-id="element-77">Comunicarnos contigo en relación a tu pedido.</li>
        </ul>
      </section>

      <section data-id="element-78">
        <h3 className="font-bold text-brand-green mb-2" data-id="element-79">
          3. Protección de Datos
        </h3>
        <p data-id="element-80">
          Implementamos medidas de seguridad técnicas y organizativas para
          proteger tu información personal contra acceso no autorizado,
          alteración, divulgación o destrucción.
        </p>
      </section>

      <section data-id="element-81">
        <h3 className="font-bold text-brand-green mb-2" data-id="element-82">4. Terceros</h3>
        <p data-id="element-83">
          No vendemos, intercambiamos ni transferimos tu información personal a
          terceros. Los proveedores de servicios de pago que utilizamos cumplen
          con los estándares de seguridad de la industria.
        </p>
      </section>

      <section data-id="element-84">
        <h3 className="font-bold text-brand-green mb-2" data-id="element-85">5. Tus Derechos</h3>
        <p data-id="element-86">
          Tienes derecho a acceder, rectificar o eliminar tu información
          personal en cualquier momento. Para ejercer estos derechos, puedes
          comunicarte con nosotros a través de los canales indicados.
        </p>
      </section>

      <section data-id="element-87">
        <h3 className="font-bold text-brand-green mb-2" data-id="element-88">6. Cookies</h3>
        <p data-id="element-89">
          Nuestro sitio puede utilizar cookies para mejorar tu experiencia de
          navegación. Puedes configurar tu navegador para rechazar cookies,
          aunque esto podría afectar la funcionalidad del sitio.
        </p>
      </section>
    </>;
}
function TermsContent() {
  return <>
      <p className="text-xs text-brand-dark/50 uppercase tracking-wider" data-id="element-90">
        Última actualización: Mayo 2026
      </p>

      <section data-id="element-91">
        <h3 className="font-bold text-brand-green mb-2" data-id="element-92">
          1. Aceptación de los Términos
        </h3>
        <p data-id="element-93">
          Al adquirir "Riqueza Integral: El Método de los 4 Cuerpos", aceptas
          estos términos y condiciones en su totalidad. Si no estás de acuerdo
          con alguno de estos términos, te recomendamos no realizar la compra.
        </p>
      </section>

      <section data-id="element-94">
        <h3 className="font-bold text-brand-green mb-2" data-id="element-95">2. Producto Digital</h3>
        <p data-id="element-96">
          El producto ofrecido es un libro digital (ebook) en formato PDF. Una
          vez completada la compra, recibirás acceso instantáneo al archivo
          descargable.
        </p>
      </section>

      <section data-id="element-97">
        <h3 className="font-bold text-brand-green mb-2" data-id="element-98">
          3. Propiedad Intelectual
        </h3>
        <p data-id="element-99">
          Todo el contenido del ebook, incluyendo texto, gráficos y diseño, está
          protegido por derechos de autor. Queda prohibida su reproducción,
          distribución o reventa sin autorización expresa por escrito.
        </p>
      </section>

      <section data-id="element-100">
        <h3 className="font-bold text-brand-green mb-2" data-id="element-101">4. Uso Personal</h3>
        <p data-id="element-102">
          La licencia adquirida es para uso personal e intransferible. No está
          permitido compartir, redistribuir o utilizar el contenido con fines
          comerciales sin autorización previa.
        </p>
      </section>

      <section data-id="element-103">
        <h3 className="font-bold text-brand-green mb-2" data-id="element-104">
          5. Descargo de Responsabilidad
        </h3>
        <p data-id="element-105">
          El contenido de este libro es de carácter informativo y educativo. No
          constituye asesoramiento financiero, médico ni profesional. Los
          resultados pueden variar según la dedicación y circunstancias
          individuales de cada persona.
        </p>
      </section>

      <section data-id="element-106">
        <h3 className="font-bold text-brand-green mb-2" data-id="element-107">
          6. Política de Reembolso
        </h3>
        <p data-id="element-108">
          Debido a la naturaleza digital del producto, no se ofrecen reembolsos
          una vez que el archivo ha sido descargado. Si experimentas problemas
          técnicos con la descarga, nos comprometemos a asistirte para resolver
          el inconveniente.
        </p>
      </section>

      <section data-id="element-109">
        <h3 className="font-bold text-brand-green mb-2" data-id="element-110">7. Modificaciones</h3>
        <p data-id="element-111">
          Nos reservamos el derecho de modificar estos términos en cualquier
          momento. Las modificaciones serán efectivas desde su publicación en
          esta página.
        </p>
      </section>
    </>;
}